import React, { Suspense, lazy } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const PT = lazy(() => import("../Portugal/AboutUsPT"));
const FR = lazy(() => import("../France/AboutUsFR"));

const AboutUsLoader = () => {

    const region = useSelector((state: RootState) => state.region.region);

    return (
        <Suspense fallback={<Spinner animation="border" variant="light" />}>
            <>
                {region === "PT" && <PT />}
                {region === "FR" && <FR />}
            </>
        </Suspense>
    );

}

export default AboutUsLoader;